























































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from '@/types'
import { LOAD_EMPLOYEE_QCQ_COMPETENCE, EDIT_EMPLOYEE_QCQ_COMPETENCE } from '@/store/action-types'
import QcqCompetenceDialog from './QcqCompetenceDialog.vue'
import { EmployeeQcqCompetence } from '@/model/employee/EmployeeQcqCompetence'
import { MasterDataActionsEnum } from '@/types/enums'
import { EmployeeQcqCompetencePayload, EmployeeCompetencePayload } from '@/types/payload'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'

interface ComponentData {
  gridData: Array<any>
  gridOptions: GridOptions
  showQcqCompetenceDialog: boolean
  selectedCompetenceId: number | undefined
  selectedCompetenceData: EmployeeQcqCompetence | undefined
  action: MasterDataActionsEnum | undefined
  loading: boolean
  showDeleteDialog: boolean
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  employeeComepetences: Array<number | null>
  errorMessage: string
  successMessage: string
  overlayNoRowsTemplate: string
  showSearchField: boolean
  search: string | null
}

interface DialogPayload {
  selectedCompetence: number | null
  quality: number | null
}

export default Vue.extend({
  name: 'QcqCompetence',

  components: {
    AgGridVue,
    QcqCompetenceDialog,
    DeleteDialog
  },

  props: {
    employeeId: Number,
    isCompetencesQualityEnabled: Boolean,
    stars: Number

  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.qcq.description'), field: 'description' },
        ]
      },
      showQcqCompetenceDialog: false,
      selectedCompetenceId: undefined,
      selectedCompetenceData: undefined,
      action: undefined,
      loading: false,
      showDeleteDialog: false,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
      employeeComepetences: [],
      errorMessage: '',
      successMessage: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      showSearchField: false,
      search: null
    }
  },

  computed: {
    isEnableButtons (): boolean {
      return !!this.selectedCompetenceId
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): any[] {
      if(this.search) {
        return this.gridData.filter((item: any) => {
          return item.description.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  watch: {
    employeeId (newVal: Number): void {
      if (newVal) {
        this.selectedCompetenceId = undefined
        this.selectedCompetenceData = undefined
        this.fetchCompetenceList()
      }
    },
  },

  methods: {
    onRowClicked (params: any): void {
      this.selectedCompetenceId = params.data.competenceId
    },

    onRowDoubleClicked (params: any): void {
      this.selectedCompetenceId = params.data.competenceId
      this.selectedCompetenceData = this.gridData.find((item: any) => item.competenceId === this.selectedCompetenceId)
      this.action = MasterDataActionsEnum.Update
      this.showQcqCompetenceDialog = true

      this.employeeComepetences = []
      this.gridData.forEach((item: any) => {
        if (item.competenceId !== this.selectedCompetenceId) {
          this.employeeComepetences.push(item.competenceId)
        }
      })
    },

    onAddCompetenceClick (): void {
      const emptyModelData: EmployeeQcqCompetencePayload = {
        id: null,
        competenceId: null,
        quality: null,
        description: undefined
      }
      this.selectedCompetenceData = EmployeeQcqCompetence.createFromData(emptyModelData)
      this.action = MasterDataActionsEnum.Create
      this.showQcqCompetenceDialog = true

      this.employeeComepetences = []
      this.gridData.forEach((item: any) => {
        this.employeeComepetences.push(item.competenceId)
      })
    },

    onEditCompetenceClick (): void {
      this.selectedCompetenceData = this.gridData.find((item: any) => item.competenceId === this.selectedCompetenceId)
      this.action = MasterDataActionsEnum.Update
      this.showQcqCompetenceDialog = true

      this.employeeComepetences = []
      this.gridData.forEach((item: any) => {
        if (item.competenceId !== this.selectedCompetenceId) {
          this.employeeComepetences.push(item.competenceId)
        }
      })
    },

    onDeleteCompetenceClick (): void {
      this.selectedCompetenceData = this.gridData.find((item: any) => item.competenceId === this.selectedCompetenceId)
      this.action = MasterDataActionsEnum.Delete
      this.showDeleteDialog = true
    },

    deleteCompetence (): void {
      if (this.selectedCompetenceData) {
        let payload: DialogPayload = {
          selectedCompetence: this.selectedCompetenceData.competenceId,
          quality: this.selectedCompetenceData.quality
        }
        this.onQcqCompetenceDialogSave(payload)
      }
      this.showDeleteDialog = false
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
      this.action = undefined
    },

    onQcqCompetenceDialogSave (dialogPayload: DialogPayload): void {
      let payload: EmployeeCompetencePayload
      if (this.action === MasterDataActionsEnum.Create) {
        payload = {
          competenceId: dialogPayload.selectedCompetence,
          action: this.action,
          employeeId: this.employeeId,
          competenceOldId: null,
          quality: dialogPayload.quality
        }
        this.competenceSave(payload)
      } else if (this.action === MasterDataActionsEnum.Update && this.selectedCompetenceData) {
        payload = {
          competenceId: dialogPayload.selectedCompetence,
          action: this.action,
          employeeId: this.employeeId,
          competenceOldId: this.selectedCompetenceData.competenceId,
          quality: dialogPayload.quality
        }
        this.competenceSave(payload)
      } else if (this.selectedCompetenceData) {
        payload = {
          competenceId: this.selectedCompetenceData.competenceId,
          action: this.action,
          employeeId: this.employeeId,
          competenceOldId: null,
          quality: this.selectedCompetenceData.quality
        }
        this.competenceSave(payload)
      }
    },

    async competenceSave (payload: EmployeeCompetencePayload): Promise<void> {
      try {
        this.loading = true
        await this.$store.dispatch(EDIT_EMPLOYEE_QCQ_COMPETENCE, payload)
        this.loading = false
        this.showQcqCompetenceDialog = false
        if (this.action === MasterDataActionsEnum.Delete) {
          this.successMessage = this.$t('success.dataHaveBeenDeleted').toString()
        } else {
          this.successMessage = this.$t('success.dataHaveBeenSaved').toString()
        }
        this.action = undefined
        this.selectedCompetenceId = undefined
        this.selectedCompetenceData = undefined
        this.showSuccessSnackbar = true
        this.fetchCompetenceList()
      } catch (e) {
        this.loading = false
        if (this.action === MasterDataActionsEnum.Delete) {
          this.errorMessage = this.$t('success.dataCouldNotBeDeleted').toString()
        } else {
          this.errorMessage = this.$t('success.dataCouldNotBeSaved').toString()
        }
        this.showErrorSnackbar = true
      }
    },

    onQcqCompetenceDialogClose (): void {
      this.showQcqCompetenceDialog = false
    },

    async fetchCompetenceList (): Promise<void> {
      const payload: number = this.employeeId
      const data = await this.$store.dispatch(LOAD_EMPLOYEE_QCQ_COMPETENCE, payload)

      this.gridData = data
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    }
  },

  mounted (): void {
    this.fetchCompetenceList()
  }

})
